import React from "react"
//import I18n from "i18n-js/index.js.erb"
import ModalButtons from "../ModalButtons/ModalButtons"
import PortalCustomerBuilderTabs from "./PortalCustomerBuilderTabs"
import PortalCustomerBuilderTabContent from "./PortalCustomerBuilderTabContent"
import LoadingSpinner from "../LoadingSpinner/LoadingSpinner"

class PortalCustomerBuilder extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      first_name: this.props.customer.first_name || null,
      middle_name: this.props.customer.middle_name || null,
      last_name: this.props.customer.last_name || null,
      email: this.props.customer.email || null,
      phone_number: this.props.customer.phone_number || null,
      formatted_phone: this.props.customer.formatted_phone || null,
      city: this.props.customer.city || null,
      state: this.props.customer.state || null,
      country: this.props.customer.country || null,
      salutation: this.props.customer.salutation || null,
      address_1: this.props.customer.address_1 || null,
      address_2: this.props.customer.address_2 || null,
      postal_code: this.props.customer.postal_code || null,
      google_token: this.props.customer.google_token || null,
      customers_edit_path: this.props.customers_edit_path,
      reset_password: this.props.reset_password || null,
      old_password: "",
      new_password: "",
      confirm_password: "",
      active_tab: 'general',
    }
    this.onChangeActiveTab = this.onChangeActiveTab.bind(this);
    this.prepParams = this.prepParams.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.onChange = this.onChange.bind(this);
  }
  
  render() {
    var buttons = [
      {
        name: I18n.t('cancel'),
        html_attributes: ['data-dismiss="modal"']
      },
      {
        name: I18n.t('submit'),
        button_classes: ['primary'],
        onClick: this.onSubmit,
      },
    ]
    return (
      <div className="dates-and-times-builder">
        <div className="panel panel-form">
          <ModalButtons loading={this.state.loading} buttons={buttons} />
          <PortalCustomerBuilderTabs onChangeActiveTab={this.onChangeActiveTab} active_tab={this.state.active_tab}/>
          <PortalCustomerBuilderTabContent {...this.state} {...this.props} onChange={this.onChange}/>
        </div>
        <LoadingSpinner show={this.state.loading} />
      </div>
    );
  }

  onChangeActiveTab(active_tab, event) {
    event.stopPropagation();
    event.preventDefault();
    this.setState({
      active_tab: active_tab
    })
  }

  onChange(event) {
    var _state = this.state;
    _state[event.target.name] = event.target.value;
    this.setState(_state);
  }

  onSubmit() {
    var self = this
    var params = self.prepParams()
    self.setState({ loading: true })
    setTimeout(function () {
      $.ajax({
        type: 'PATCH',
        url: self.state.customers_edit_path,
        data: params
      }).done(function (data) {
        self.setState({ loading: false })
        window.parent.$(window.parent).trigger("customerSavedSuccessfully", data)
        if (parent && parent.refresh_data) {
          parent.refresh_data(data.success)
        }
        if (parent && parent.hide_modal) {
          parent.hide_modal()
        }
      })
    }, 1000)
  }

  prepParams() {
    return {
      customer: {
        first_name: this.state.first_name || null,
        middle_name: this.state.middle_name || null,
        last_name: this.state.last_name || null,
        email: this.state.email || null,
        phone_number: this.state.phone_number || null,
        formatted_phone: this.state.formatted_phone || null,
        city: this.state.city || null,
        state: this.state.state || null,
        country: this.state.country || null,
        salutation: this.state.salutation || null,
        address_1: this.state.address_1 || null,
        address_2: this.state.address_2 || null,
        postal_code: this.state.postal_code || null,
        google_token: this.state.google_token || null,
        old_password: this.state.old_password || null,
        new_password: this.state.new_password || null,
        confirm_password: this.state.confirm_password || null,
      },
    }
  }
};

export default PortalCustomerBuilder